import { render, staticRenderFns } from "./IssuesListView.vue?vue&type=template&id=69fa7e12&"
import script from "./IssuesListView.vue?vue&type=script&lang=js&"
export * from "./IssuesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports